import React from 'react'

import { ReactComponent as Success } from 'assets/icons/group.svg'
import './loader.css'

const Loader = ({ showSubTitle = true }) => {
    return (
        <div
            className="bg-white br-4 br-4 o-hidden d-flex flex-column flex-center"
            style={{
                width: '400px',
                height: '468px'
            }}
        >
            <div className="d-flex flex-column flex-middle flex-center">
                <div className="loader"></div>
                <div className="fs-5 fw-600 c-neutral-900 mt-3">Hang on</div>
                {showSubTitle && <div className="fs-3 mt-1 c-neutral-900">We need a few more details..</div>}
            </div>
        </div>
    )
}

export default Loader
